import MuiCheckbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import styled from 'styled-components';

type CbProps = {
    $error?: boolean;
};

export const Cb = styled(MuiCheckbox)<CbProps>`
    color: ${(props) =>
        props.$error ? props.theme.palette.secondaryA4 : props.theme.palette.primaryA1};

    position: absolute;

    &.Mui-checked {
        color: ${(props) =>
            props.$error ? props.theme.palette.secondaryA4 : props.theme.palette.primaryA1};
    }

    &.Mui-disabled {
        opacity: 0.5;
    }
`;

export const FormControlLabelStyled = styled(FormControlLabel)`
    margin-right: 0;
    position: relative;
    &:before {
        content: '';
        width: 42px;
        height: 24px;
        flex-shrink: 0;
    }
`;
